import $ from "jquery";
import "slick-carousel";
import dayjs from "dayjs";

export const Schedule = function () {
	if (!($("#schedule").length > 0)) return false;

	const $timeTable = $(".js-timetable-item");
	let activeIndex = $timeTable.filter(".active").index();
	if (activeIndex === -1) {
		activeIndex = 0;
	}

	$(".js-date-slider").slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: $("#prev"),
		nextArrow: $("#next"),
		dots: false,
		initialSlide: activeIndex,
		asNavFor: ".js-timetable-slider",
		swipe: false,
		draggable: false,
		touchMove: false,
		speed: 200,
	});

	$(".js-timetable-slider").slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		initialSlide: activeIndex,
		asNavFor: ".js-date-slider",
		swipe: false,
		draggable: false,
		touchMove: false,
		speed: 200,
	});

	const $elms = {
		session: $(".js-session"),
		btnCloseSession: $(".js-close-session-btn"),
		sessionWrapper: $(".session"),
		btnBack: $(".js-back-btn"),
		btnShowMap: $(".js-show-map-btn"),
		map: $(".map"),
		currentTime: $(".js-currentTime"),
		groupSwitch: $(".js-group-switch"),
	};

	$elms.session.on("click", function () {
		const $this = $(this);
		const sessionId = $this.attr("data-session");

		if (sessionId) {
			const session = window.CFG.sessions.find(
				(s) => s.ID === parseInt(sessionId),
			);
			if (session) {
				const $sessionImage = $("#session-image");
				const $sessionTitle = $("#session-title");
				const $sessionContent = $("#session-content");
				const $sessionRoom = $("#session-room");
				const sessionTime = $("#session-time");

				if (session.image) {
					$sessionImage.find("img").attr("src", session.image);
					$sessionImage.show();
				} else {
					$sessionImage.hide();
				}

				if (session.locations) {
					$sessionRoom.html(
						session.locations.map((location) => location.post_title).join(", "),
					);
					if (session.color) {
						$sessionRoom.css("background-color", session.color);
					} else {
						$sessionRoom.css("background-color", "#add61c");
					}
					$sessionRoom.show();
				} else {
					$sessionRoom.hide();
				}

				const startTime = dayjs(session.datetime_start).format("HH:mm");
				const endTime = dayjs(session.datetime_finish).format("HH:mm");

				sessionTime.html(`${startTime} - ${endTime}`);

				$sessionTitle.text(session.post_title);
				$sessionContent.html(session.post_content);

				$elms.sessionWrapper.addClass("is-open");
			}
		}
	});

	$elms.btnCloseSession.on("click", function () {
		$elms.sessionWrapper.removeClass("is-open");
	});

	$elms.btnBack.on("click", function () {
		if (
			window.history.length > 1 &&
			document.referrer.indexOf(window.location.origin) === 0
		) {
			window.history.back();
		} else {
			window.location.href = "/";
		}
	});

	$elms.btnShowMap.on("click", function () {
		const url = $(this).attr("data-url");
		if (url) {
			$elms.sessionWrapper.removeClass("is-open");
			window.location.href = url;
		}
	});

	$elms.groupSwitch.on("click", function () {
		const $this = $(this);

		$this.addClass("is-active");
		$this.siblings().removeClass("is-active");
		const groupId = $this.attr("data-group");
		if (groupId === "all") {
			$elms.session.show();
		} else {
			$elms.session.hide();
			$elms.session
				.filter(function () {
					const groups = $(this).attr("data-group").split(",");
					return groups.includes(groupId);
				})
				.show();
		}
	});

	function scrollToCurrentTime() {
		const $currentTimeBar = $(".js-current-time");
		if (!$currentTimeBar.length) return;

		const currentTime = $currentTimeBar.attr("data-time");

		const $timeElements = $(".slick-current .js-time");

		let $targetElement = null;
		let minDiff = Infinity;

		$timeElements.each(function () {
			const timeValue = $(this).attr("data-time");

			if (timeValue) {
				const [currentHours, currentMinutes] = currentTime
					.split(":")
					.map(Number);
				const [timeHours, timeMinutes] = timeValue.split(":").map(Number);

				const currentTotalMinutes = currentHours * 60 + currentMinutes;
				const timeTotalMinutes = timeHours * 60 + timeMinutes;

				const diff = Math.abs(currentTotalMinutes - timeTotalMinutes);

				if (diff < minDiff) {
					minDiff = diff;
					$targetElement = $(this);
				}
			}
		});

		if ($targetElement) {
			const $activeTimeTable = $(".js-timetable-item.active");
			const $container = $activeTimeTable.find(".js-sessions");

			const isReversedAxis = $(".schedule").hasClass("is-reversedAxis");
			if (isReversedAxis) {
				const elementLeft = $targetElement.offset().left;
				const containerLeft = $container.offset().left;
				const scrollPosition = elementLeft - containerLeft;

				setTimeout(() => {
					$container.animate({ scrollLeft: scrollPosition }, 200);
				}, 300);
			} else {
				const elementTop = $targetElement.offset().top;
				const containerTop = $container.offset().top;
				const scrollPosition = elementTop - containerTop;

				setTimeout(() => {
					$container.animate({ scrollTop: scrollPosition }, 200);
				}, 300);
			}
		}
	}

	function updateCurrentTimeBar() {
		let worker;
		let maxGap = 0;
		let lastUpdate = new Date().getMinutes();
		const $currentTimeBar = $(".js-current-time");

		function handleTimeUpdate(data) {
			const { minutes, seconds } = data;

			if (minutes % 5 === 0 && seconds === 0 && lastUpdate !== minutes) {
				const className = $currentTimeBar.attr("class") || "";
				const match = className.match(/\bat-(\d+)/);
				const number = match ? parseInt(match[1], 10) : null;

				$currentTimeBar.removeClass(function (index, className) {
					return (className.match(/\bat-\d+/g) || []).join(" ");
				});

				if (maxGap > number) {
					$currentTimeBar.addClass(`at-${number + 1}`);
					lastUpdate = minutes;
				} else {
					if (worker) {
						worker.postMessage("stop");
						worker.terminate();
						worker = null;
					}
					$currentTimeBar.remove();
				}
			}
		}

		function startWorker() {
			try {
				const workerCode = `
					// Time update worker
					let timerId = null;

					function checkTime() {
						const now = new Date();
						const minutes = now.getMinutes();
						const seconds = now.getSeconds();

						// Send current time to main thread
						postMessage({
							time: now.getTime(),
							minutes,
							seconds,
						});

						// Check every second
						timerId = setTimeout(checkTime, 1000);
					}

					// Start checking time when worker starts
					checkTime();

					// Listen for messages from main thread
					self.onmessage = (e) => {
						if (e.data === "stop") {
							clearTimeout(timerId);
						}
					};

					// Cleanup when worker is terminated
					self.addEventListener("close", () => {
						// console.log("Worker shutting down");
					});
				`;

				const blob = new Blob([workerCode], { type: "text/javascript" });
				const workerUrl = URL.createObjectURL(blob);
				worker = new Worker(workerUrl, { type: "module" });

				worker.onmessage = (e) => {
					handleTimeUpdate(e.data);
				};

				worker.onerror = (error) => {
					console.error("Time worker error:", error);
					worker.terminate();
					worker = null;
					URL.revokeObjectURL(workerUrl); // Clean up the Blob URL
				};
			} catch (error) {
				console.error("Failed to create time worker:", error);
			}
		}

		if ($currentTimeBar.length) {
			maxGap = parseInt($currentTimeBar.attr("max-gap"));
			startWorker();
		}
	}

	// Synchronized scrolling functionality
	function initSynchronizedScrolling() {
		const $timetable = $(".js-sessions");
		const $fixedTimes = $(".schedule__body-timetable--times");

		// Only proceed if both elements exist
		if ($timetable.length === 0 || $fixedTimes.length === 0) return;

		let isScrolling = false;

		// Sync scroll from timetable to fixed times
		$timetable.on("scroll", function () {
			if (!isScrolling) {
				isScrolling = true;
				const scrollTop = $(this).scrollTop();

				$fixedTimes.scrollTop(scrollTop);

				// Prevent infinite loop
				setTimeout(() => {
					isScrolling = false;
				}, 10);
			}
		});
	}

	function initSynchronizedScrollingHorizontal() {
		const $timetable = $(".js-sessions");
		const $fixedTimes = $(".js-locations");

		// Only proceed if both elements exist
		if ($timetable.length === 0 || $fixedTimes.length === 0) return;

		let isScrolling = false;

		// Sync scroll from timetable to fixed times
		$timetable.on("scroll", function () {
			if (!isScrolling) {
				isScrolling = true;

				const scrollLeft = $(this).scrollLeft();
				$fixedTimes.scrollLeft(scrollLeft);

				// Prevent infinite loop
				setTimeout(() => {
					isScrolling = false;
				}, 10);
			}
		});
	}

	// Synchronized scrolling functionality
	function initSynchronizedScrollingFlipped() {
		const $timetable = $(".js-sessions");
		const $fixedTimes = $(".schedule__body-timetable--times");

		// Only proceed if both elements exist
		if ($timetable.length === 0 || $fixedTimes.length === 0) return;

		let isScrolling = false;

		// Sync scroll from timetable to fixed times
		$timetable.on("scroll", function () {
			if (!isScrolling) {
				isScrolling = true;
				const scrollLeft = $(this).scrollLeft();

				$fixedTimes.scrollLeft(scrollLeft);

				// Prevent infinite loop
				setTimeout(() => {
					isScrolling = false;
				}, 10);
			}
		});
	}

	function initSynchronizedScrollingHorizontalFlipped() {
		const $timetable = $(".js-sessions");
		const $fixedTimes = $(".js-locations");

		// Only proceed if both elements exist
		if ($timetable.length === 0 || $fixedTimes.length === 0) return;

		let isScrolling = false;

		// Sync scroll from timetable to fixed times
		$timetable.on("scroll", function () {
			if (!isScrolling) {
				isScrolling = true;

				const scrollTop = $(this).scrollTop();
				$fixedTimes.scrollTop(scrollTop);

				// Prevent infinite loop
				setTimeout(() => {
					isScrolling = false;
				}, 10);
			}
		});
	}

	scrollToCurrentTime();
	updateCurrentTimeBar();
	initSynchronizedScrolling();
	initSynchronizedScrollingHorizontal();

	const $schedule = $(".schedule");
	if ($schedule.hasClass("is-reversedAxis")) {
		initSynchronizedScrollingFlipped();
		initSynchronizedScrollingHorizontalFlipped();
	} else {
		initSynchronizedScrolling();
		initSynchronizedScrollingHorizontal();
	}
};
